/**
 * Auto-generated at build time. Do not edit.
 * Fallback timestamps from page JS file modification dates.
 * Used when a page does not provide explicit PAGE_LAST_UPDATED config.
 */
export const pageTimestamps = {
  "BioPage": {
    "dateTime": "2026-02-18",
    "displayDate": "February 18, 2026"
  },
  "HomePage": {
    "dateTime": "2026-02-18",
    "displayDate": "February 18, 2026"
  }
};
